module.exports = __webpack_public_path__ + "img/Category_light.f900f159.svg";